var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "aside",
        {
          staticClass: "wkb-filter-popup",
          style: _vm.aiAssistantOpen
            ? { right: "calc(12px + min(380px, calc(100% - 24px)) + 8px)" }
            : {},
          attrs: {
            role: "dialog",
            "aria-modal": "false",
            "aria-labelledby": "wkb-filter-title",
          },
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
            mousedown: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c("header", { staticClass: "wkb-filter-head" }, [
            _c("div", { staticClass: "wkb-filter-head-row" }, [
              _c("h2", { attrs: { id: "wkb-filter-title" } }, [
                _vm._v("Build a visibility filter"),
              ]),
              _c(
                "button",
                {
                  staticClass: "wkb-filter-close",
                  attrs: {
                    type: "button",
                    "aria-label": "Close",
                    disabled: _vm.loading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v(" × ")]
              ),
            ]),
            _c("p", { staticClass: "wkb-filter-intro" }, [
              _vm._v(
                " Build filters annotate nodes on the graph. Toggle filters on or off to change what is visible without rebuilding. "
              ),
            ]),
          ]),
          _c("div", { staticClass: "wkb-filter-tabrow" }, [
            _c(
              "div",
              {
                staticClass: "wkb-filter-tabs",
                attrs: {
                  role: "tablist",
                  "aria-label": "Filter panel sections",
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "wkb-filter-tab",
                    class: { "is-active": _vm.activeTab === "filters" },
                    attrs: {
                      id: _vm.tabButtonId("filters"),
                      type: "button",
                      role: "tab",
                      "aria-selected":
                        _vm.activeTab === "filters" ? "true" : "false",
                      "aria-controls": _vm.tabPanelId("filters"),
                    },
                    on: {
                      click: function ($event) {
                        _vm.activeTab = "filters"
                      },
                    },
                  },
                  [
                    _vm._v(" Filters "),
                    _vm.savedFilters.length
                      ? _c("span", { staticClass: "wkb-filter-tab-count" }, [
                          _vm._v(_vm._s(_vm.savedFilters.length)),
                        ])
                      : _vm._e(),
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass: "wkb-filter-tab",
                    class: { "is-active": _vm.activeTab === "create" },
                    attrs: {
                      id: _vm.tabButtonId("create"),
                      type: "button",
                      role: "tab",
                      "aria-selected":
                        _vm.activeTab === "create" ? "true" : "false",
                      "aria-controls": _vm.tabPanelId("create"),
                    },
                    on: {
                      click: function ($event) {
                        _vm.activeTab = "create"
                      },
                    },
                  },
                  [_vm._v(" Create filters ")]
                ),
              ]
            ),
          ]),
          _c("div", { staticClass: "wkb-filter-body" }, [
            _c(
              "section",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab === "filters",
                    expression: "activeTab === 'filters'",
                  },
                ],
                staticClass: "wkb-filter-tab-panel",
                attrs: {
                  id: _vm.tabPanelId("filters"),
                  role: "tabpanel",
                  "aria-labelledby": _vm.tabButtonId("filters"),
                },
              },
              [
                !_vm.savedFilters.length
                  ? _c("p", { staticClass: "wkb-filter-saved-empty" }, [
                      _vm._v(
                        " No filters yet. Switch to Create filters to configure and build one. "
                      ),
                    ])
                  : _c(
                      "ul",
                      {
                        staticClass: "wkb-filter-saved-list",
                        attrs: { "aria-label": "Saved filters" },
                      },
                      _vm._l(_vm.savedFilters, function (filter, index) {
                        return _c(
                          "li",
                          {
                            key: filter.id,
                            staticClass: "wkb-filter-saved-item",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "wkb-filter-bubble",
                                class: {
                                  "is-disabled": filter.enabled === false,
                                },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "wkb-filter-bubble-toggle",
                                    attrs: {
                                      type: "button",
                                      "aria-pressed":
                                        filter.enabled !== false
                                          ? "true"
                                          : "false",
                                      title:
                                        filter.enabled !== false
                                          ? "Disable filter visibility"
                                          : "Enable filter visibility",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit(
                                          "toggle-filter",
                                          filter.id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "wkb-filter-bubble-index",
                                      },
                                      [_vm._v(_vm._s(index + 1))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "wkb-filter-bubble-label",
                                      },
                                      [_vm._v(_vm._s(filter.name))]
                                    ),
                                  ]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "wkb-filter-bubble-remove",
                                    attrs: {
                                      type: "button",
                                      "aria-label": "Remove filter",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit(
                                          "remove-filter",
                                          filter.id
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" × ")]
                                ),
                              ]
                            ),
                            index < _vm.savedFilters.length - 1
                              ? _c("hr", {
                                  staticClass: "wkb-filter-divider",
                                  attrs: { "aria-hidden": "true" },
                                })
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                _vm.savedFilters.length
                  ? _c("div", { staticClass: "wkb-filter-saved-meta" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.visibleNodeCount) +
                          " of " +
                          _vm._s(_vm.nodeCount) +
                          " nodes visible on canvas. "
                      ),
                    ])
                  : _vm._e(),
                _vm.invisibleNodeCount > 0
                  ? _c("div", { staticClass: "wkb-filter-remove-invisible" }, [
                      _c("hr", {
                        staticClass: "wkb-filter-divider",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _c(
                        "p",
                        { staticClass: "wkb-filter-remove-invisible-note" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.invisibleNodeCount) +
                              " node" +
                              _vm._s(_vm.invisibleNodeCount === 1 ? "" : "s") +
                              " " +
                              _vm._s(
                                _vm.invisibleNodeCount === 1 ? "is" : "are"
                              ) +
                              " currently hidden by active filters. "
                          ),
                        ]
                      ),
                      !_vm.confirmRemoveInvisible
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "wkb-filter-btn wkb-filter-btn-danger-outline",
                              attrs: {
                                type: "button",
                                disabled:
                                  _vm.loading || _vm.removeInvisibleDisabled,
                              },
                              on: {
                                click: function ($event) {
                                  _vm.confirmRemoveInvisible = true
                                },
                              },
                            },
                            [_vm._v(" Remove invisible nodes from graph ")]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "wkb-filter-remove-invisible-confirm",
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  "Permanently remove " +
                                    _vm._s(_vm.invisibleNodeCount) +
                                    " hidden node(s)?"
                                ),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "wkb-filter-remove-invisible-actions",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "wkb-filter-btn wkb-filter-btn-secondary",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.loading,
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.confirmRemoveInvisible = false
                                        },
                                      },
                                    },
                                    [_vm._v(" Cancel ")]
                                  ),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "wkb-filter-btn wkb-filter-btn-danger",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.loading,
                                      },
                                      on: {
                                        click: _vm.onConfirmRemoveInvisible,
                                      },
                                    },
                                    [_vm._v(" Remove permanently ")]
                                  ),
                                ]
                              ),
                            ]
                          ),
                    ])
                  : _vm._e(),
              ]
            ),
            _c(
              "section",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab === "create",
                    expression: "activeTab === 'create'",
                  },
                ],
                staticClass: "wkb-filter-tab-panel wkb-filter-builder",
                attrs: {
                  id: _vm.tabPanelId("create"),
                  role: "tabpanel",
                  "aria-labelledby": _vm.tabButtonId("create"),
                },
              },
              [
                !_vm.nodeCount
                  ? _c("p", { staticClass: "wkb-filter-empty" }, [
                      _vm._v(" Build a graph before creating filters. "),
                    ])
                  : [
                      _vm.loading && _vm.progressLabel
                        ? _c(
                            "p",
                            {
                              staticClass: "wkb-filter-progress",
                              attrs: { role: "status" },
                            },
                            [
                              _c("span", {
                                staticClass: "wkb-filter-spinner",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(" " + _vm._s(_vm.progressLabel) + " "),
                            ]
                          )
                        : _vm._e(),
                      !_vm.llmAvailable && _vm.filterNeedsLlm
                        ? _c(
                            "p",
                            {
                              staticClass: "wkb-filter-llm-note",
                              attrs: { role: "note" },
                            },
                            [
                              _vm._v(
                                " LLM filtering is not available — the interactive API did not report an LLM backend. "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c("label", { staticClass: "wkb-filter-type-field" }, [
                        _c("span", { staticClass: "wkb-filter-label" }, [
                          _vm._v("Filter type"),
                        ]),
                        _c(
                          "select",
                          {
                            staticClass: "wkb-filter-type-select",
                            attrs: {
                              id: `${_vm.panelId}-create-filter-type`,
                              disabled: _vm.loading,
                            },
                            domProps: { value: _vm.createFilterType },
                            on: { change: _vm.onCreateFilterTypeChange },
                          },
                          _vm._l(
                            _vm.createFilterTypeOptions,
                            function (option) {
                              return _c(
                                "option",
                                {
                                  key: option.value,
                                  domProps: { value: option.value },
                                },
                                [_vm._v(" " + _vm._s(option.label) + " ")]
                              )
                            }
                          ),
                          0
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.createFilterType === "intent",
                              expression: "createFilterType === 'intent'",
                            },
                          ],
                          staticClass: "wkb-filter-option wkb-filter-intent",
                        },
                        [
                          _vm._m(0),
                          _c("small", { staticClass: "wkb-filter-hint" }, [
                            _vm._v(
                              " Describe what should stay on the graph. When you build, nodes that match this intent remain visible; others are hidden. "
                            ),
                          ]),
                          _c("textarea", {
                            staticClass: "wkb-filter-textarea",
                            attrs: {
                              id: "wkb-filter-intent",
                              rows: "2",
                              disabled: _vm.loading,
                              placeholder:
                                "e.g. genes and mechanisms linked to insulin resistance",
                            },
                            domProps: { value: _vm.filters.intent || "" },
                            on: { input: _vm.onIntentInput },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { staticClass: "wkb-filter-intent-suboption" },
                            [
                              _c("input", {
                                attrs: {
                                  type: "checkbox",
                                  disabled: _vm.loading || !_vm.intentHasText,
                                },
                                domProps: {
                                  checked:
                                    _vm.filters.relevanceMode === "semantic",
                                },
                                on: { change: _vm.onSemanticToggle },
                              }),
                              _c("span", [_vm._v("Semantic similarity")]),
                            ]
                          ),
                          _vm.intentHasText &&
                          _vm.filters.relevanceMode === "semantic"
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "wkb-filter-helper wkb-filter-intent-helper",
                                },
                                [
                                  _vm._v(
                                    " Matching uses semantic similarity to your intent, combined with the session context. "
                                  ),
                                ]
                              )
                            : _vm.intentHasText
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "wkb-filter-helper wkb-filter-intent-helper",
                                },
                                [
                                  _vm._v(
                                    " Matching uses LLM relevance to your intent, combined with the session context. "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "fieldset",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.createFilterType === "novelty",
                              expression: "createFilterType === 'novelty'",
                            },
                          ],
                          staticClass: "wkb-filter-option wkb-filter-novelty",
                          attrs: { disabled: _vm.loading },
                        },
                        [
                          _vm._m(1),
                          _c("p", { staticClass: "wkb-filter-novelty-intro" }, [
                            _vm._v(
                              " Annotate nodes by novelty labels from candidate classification. "
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "wkb-filter-novelty-options" },
                            [
                              _c(
                                "label",
                                { staticClass: "wkb-filter-novelty-option" },
                                [
                                  _c("input", {
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Boolean(
                                        _vm.filters.noveltyKnown
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit(
                                          "toggle-novelty",
                                          "known"
                                        )
                                      },
                                    },
                                  }),
                                  _c("span", [_vm._v("Known")]),
                                ]
                              ),
                              _c(
                                "label",
                                { staticClass: "wkb-filter-novelty-option" },
                                [
                                  _c("input", {
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Boolean(
                                        _vm.filters.noveltyNovel
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit(
                                          "toggle-novelty",
                                          "novel"
                                        )
                                      },
                                    },
                                  }),
                                  _c("span", [_vm._v("Novel")]),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "section",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.createFilterType === "expression",
                              expression: "createFilterType === 'expression'",
                            },
                          ],
                          staticClass:
                            "wkb-filter-option wkb-filter-expression",
                        },
                        [
                          _c(
                            "h4",
                            { staticClass: "wkb-filter-subsection-title" },
                            [_vm._v("Gene expression filter")]
                          ),
                          _c("WorkspaceExpressionFilterControls", {
                            attrs: {
                              filters: _vm.filters,
                              options: _vm.expressionOptions,
                              compact: "",
                              "use-select-dropdowns": "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("patch-filters", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
              ],
              2
            ),
          ]),
          _vm.activeTab === "create" && _vm.nodeCount
            ? _c("div", { staticClass: "wkb-filter-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "wkb-filter-btn wkb-filter-btn-secondary",
                    attrs: {
                      type: "button",
                      disabled: _vm.loading || !_vm.canClearDraft,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("clear-draft")
                      },
                    },
                  },
                  [_vm._v(" Clear form ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "wkb-filter-btn wkb-filter-btn-primary",
                    attrs: {
                      type: "button",
                      disabled:
                        _vm.loading ||
                        !_vm.canBuild ||
                        (!_vm.llmAvailable && _vm.filterNeedsLlm),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("build")
                      },
                    },
                  },
                  [_vm._v(" Build filter ")]
                ),
              ])
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "wkb-filter-option-head" }, [
      _c(
        "label",
        {
          staticClass: "wkb-filter-label",
          attrs: { for: "wkb-filter-intent" },
        },
        [_vm._v("Intent")]
      ),
      _c(
        "span",
        {
          staticClass: "wkb-filter-ai-badge",
          attrs: { title: "Uses LLM or semantic classification" },
        },
        [_vm._v("AI")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "wkb-filter-option-head" }, [
      _c("legend", { staticClass: "wkb-filter-novelty-legend" }, [
        _vm._v("Known / Novel"),
      ]),
      _c(
        "span",
        {
          staticClass: "wkb-filter-ai-badge",
          attrs: { title: "Uses LLM classification" },
        },
        [_vm._v("AI")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }